import {
  Rocket,
  Clock,
  Users2,
  ShieldCheck,
  Globe2,
  Map,
  Headphones,
  Wallet,
} from "lucide-react";

const ITEMS = [
  { icon: Rocket, title: "Atendimento Imediato" },
  { icon: Clock, title: "Funcionamento 24 Horas" },
  { icon: Users2, title: "Equipe Experiente" },
  { icon: ShieldCheck, title: "Segurança no Transporte" },
  { icon: Map, title: "Atendimento em toda Região" },
  { icon: Globe2, title: "Viagens para Outros Estados" },
  { icon: Headphones, title: "Suporte Rápido" },
  { icon: Wallet, title: "Excelente Custo-Benefício" },
];

export const Differentials = () => {
  return (
    <section
      data-testid="differentials-section"
      className="section-pad bg-[#141414] border-y border-[#2d3748]"
    >
      <div className="container-custom">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="overline">Por Que Escolher a Ventania</span>
            <h2 className="mt-3 font-display uppercase font-bold text-white text-4xl md:text-5xl leading-tight tracking-tight">
              Diferenciais que fazem a{" "}
              <span className="text-[#d90429]">diferença</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={i}
                data-testid={`differential-${i}`}
                className="card-dark p-6 flex flex-col gap-4"
              >
                <Icon className="w-9 h-9 text-[#d90429]" />
                <h3 className="font-display uppercase font-bold text-white text-base md:text-lg leading-tight">
                  {it.title}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
